/* eslint-disable @typescript-eslint/no-unused-vars */
import { useContext } from "react";
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { AuthContext } from "../auth/context/auth-context";
import { Login } from "../components/login/login";
import Navbar from "../components/navbar/navbar";
import IPERCAreas from "../pages/iperc/Configuraciones/Areas/ConfiguracionAreasIperc";
import IPERCUbicaciones from "../pages/iperc/ubicacion";
import ListarEquipoModelo from "../pages/listaVerificacion/equipoModelo";
import ListaVerificacionHistorial from "../pages/listaVerificacion/historial";
import ListaVerificacionMantenimiento from "../pages/listaVerificacion/mantenimiento";
import DetallePersona from "../pages/personas/DetallePersona";
import ListadoSupervisores from "../pages/personas/Supervisores/ListadoSupervisores";
import MandoIPERC from "../pages/iperc/MandoIPERC";
import MandoCheckList from "../pages/listaVerificacion/MandoCheckList";
import DellateEquipoModelo from "../pages/listaVerificacion/Configuraciones/DetalleEquipoModelo";
import VistaDispositivos from "../pages/personas/Dispositivos/ListDispositivos/ListaDispositivos";
import PersonasView from "../pages/personas/PersonasView";
import ListaVerificacionVita from "../pages/listaVerificacion/CheckList/ListaVerficacionVista";
import IpercBaseVista from "../pages/iperc/ipercBase/ipercBaseVista";
import ConfiguracionVistaBase from "../pages/listaVerificacion/Configuraciones/ConfiguracionesVistaBase";
import { ConfigHelper, IS_PROD } from "../utils/helpers/configHelper";
import { CSSObject } from "styled-components";
import GestionUsuarios from "../pages/configuraciones/gestionUsuarios/GestionUsuarios";
import VistaReportes from "../pages/configuraciones/reportes/VistaReportes";
import { DispositivosAsignados } from "../pages/personas/Dispositivos/ListDispositivos/DispositivosAsignados";
import { DispositivoHistorico } from "../pages/personas/Dispositivos/ListDispositivos/DispositivoHistorico";
import { DispositivosDevueltos } from "../pages/personas/Dispositivos/ListDispositivos/DispositivosDevueltos";
import { ConfiguracionMenu } from "../pages/listaVerificacion/Configuraciones/ConfiguracionMenu";
import { ConfigModelosEquipos } from "../pages/listaVerificacion/Configuraciones/ConfigModelosEquipos";
import { ConfigAsignacionEquipos } from "../pages/listaVerificacion/Configuraciones/ConfigAsignacionEquipos";
import { ConfigTipoEquipos } from "../pages/listaVerificacion/Configuraciones/ConfigTipoEquipos";
import { ConfigEquipoCheckList } from "../pages/listaVerificacion/Configuraciones/ConfigEquipoCheckList";
import TablaLineaBase from "../pages/iperc/LineaBase/TablaLineaBase";
import TablaMapaPorceso from "../pages/iperc/LineaBase/TablaMapaPorceso";
import { SupervisorHistorial } from "../pages/listaVerificacion/historial/SupervisorHistorial/SupervisorHistorial";
import { SupervisorHistorialIperc } from "../pages/iperc/historial/SupervisorHistorialIperc/SupervisorHistorialIperc";
import { AdminHistorialIperc } from "../pages/iperc/historial/AdminHistorialIperc/AdminHistorialIperc";
import { ConfiguracionMenuIperc } from "../pages/iperc/Configuraciones/ConfiguracionMenuIperc";
import ConfiguracionAreasIperc from "../pages/iperc/Configuraciones/Areas/ConfiguracionAreasIperc";
import { ConfiguracionEquiposIperc } from "../pages/iperc/Configuraciones/Equipos/ConfiguracionEquiposIperc";
import { ConfiguracionActividadesIperc } from "../pages/iperc/Configuraciones/Actividades/ConfiguracionActividadesIperc";
import { MapaProcesos } from "../pages/iperc/LineaBase/MapaProcesos";
import Sidebar from "../components/SSidebar/sidebar";
import { CuadroMandoGestionUsuarios } from "../pages/configuraciones/gestionUsuarios/CuadroMandoGestionUsuarios";
import { UsuarioCuenta } from "../pages/configuraciones/gestionUsuarios/UsuarioCuenta";
import { ReporteGeneralIperc } from "../pages/iperc/historial/AdminHistorialIperc/reporte/ReporteGeneralIperc";
import { ReporteHistoricoChecklist } from "../pages/listaVerificacion/reporte/ReporteHistoricoChecklist";
import { VistaTiposDocumentos } from "../pages/gestionDocumentos/tipos/VistaTiposDocumentos";
import { VistaGruposDocumentos } from "../pages/gestionDocumentos/grupos/VistaGruposDocumentos";
import { VistaGestionDocumentos } from "../pages/gestionDocumentos/documentos/VistaGestionDocumentos";
import VistaListaReportes from "../pages/configuraciones/reportes/VistaListaReporte";
import { TablaDispositivos } from "../pages/personas/Dispositivos/TablaDispositivos";
import { ConfiguracionAuxiliarMenu } from "../pages/auxiliar/configuraciones/ConfiguracionAuxiliarMenu";
import { Turno } from "../pages/auxiliar/configuraciones/turno/Turno";
import { Razon } from "../pages/auxiliar/configuraciones/razon/Razon";
import { RazonModelo } from "../pages/auxiliar/configuraciones/razonModelo/RazonModelo";
import { Tajo } from "../pages/auxiliar/configuraciones/ubicaciones/tajo/Tajo";
import { Region } from "../pages/auxiliar/configuraciones/ubicaciones/region/Region";
import { EstadoEquipo } from "../pages/auxiliar/estadoEquipos/EstadoEquipo";
import { Ubi } from "../pages/auxiliar/configuraciones/ubicaciones/ubicacion/Ubi";
import { Equipo } from "../pages/auxiliar/equipos/Equipo";
import { DetalleEquipo } from "../pages/auxiliar/equipos/DetalleEquipo/DetalleEquipo";
import { EquipoModeloTable } from "../pages/auxiliar/configuraciones/equipoModelo/EquipoModeloTable";
import { TipoEquipoTable } from "../pages/auxiliar/configuraciones/tipoEquipo/TipoEquipoTable";
import { Operador } from "../pages/auxiliar/operadores/Operador";
import { ReporteHistoricoEstado } from "../pages/auxiliar/reportes/historicoEstadoEquipo/ReporteHistoricoEstado";
import { FormularioHazard } from "../pages/hazard/FormularioHazard";
import { TablaHazard } from "../pages/hazard/TablaHazard/TablaHazard";
import { HazardConfiguracionMenu } from "../pages/hazard/configuraciones/HazardConfiguracionMenu";
import { IncidenteTable } from "../pages/hazard/configuraciones/incidentes/IncidenteTable";
import { CatalogoTable } from "../pages/hazard/configuraciones/catalogo/CatalogoTable";
import { ElementosEstandarTable } from "../pages/hazard/configuraciones/elementosEstandar/ElementosEstandarTable";
import { UbicacionHazard } from "../pages/hazard/configuraciones/ubicaciones/UbicacionHazard";
import { EquipoModeloOperadorTable } from "../pages/auxiliar/configuraciones/equipoModeloOperador/EquipoModeloTable/EquipoModeloOperadorTable";
import PrivateRoute from "../components/route/PrivateRoute";
import { RolesRuta } from "../auth/constantes/authRol";

const outletStyle: CSSObject = {
  width: "100%",
  overflowY: "auto",
  height: "calc(100vh - 3rem)",
};

const Verified = () => {
  const { token } = useContext(AuthContext);
  const location = useLocation();

  if (!token) {
    return (
      <Navigate
        to={`${ConfigHelper.urlLogin()}`}
        state={{ from: location }}
        replace
      />
    );
  }

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ position: "fixed", width: "100%", zIndex: "1000" }}>
          <Navbar />
        </div>
        <div style={{ display: "flex", top: "48px", position: "relative" }}>
          <div>
            <Sidebar />
          </div>
          <div style={outletStyle}>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export const ContentRouter = () => {
  return (
    <>
      <Routes>
        <Route path={ConfigHelper.urlLogin()} element={<Login />} />
        <Route path={`${IS_PROD ? "/" : "/ssoma"}`} element={<Verified />}>
          {/* 1. Gestion Personas */}
          <Route path="listaverificacion">
            <Route
              path="CheckList"
              element={
                <PrivateRoute allowedRoles={RolesRuta.IPERC_CHECKLIST}>
                  <ListaVerificacionVita />
                </PrivateRoute>
              }
            />
            <Route
              path="mantenimiento"
              element={
                <PrivateRoute
                  allowedRoles={RolesRuta.LISTAVERIFICACION_MANTENIMIENTO}
                >
                  <ListaVerificacionMantenimiento />
                </PrivateRoute>
              }
            />
            <Route
              path="CuadroMando"
              element={
                <PrivateRoute allowedRoles={RolesRuta.LISTAVERIFICACION_CM}>
                  <MandoCheckList />
                </PrivateRoute>
              }
            />
            <Route path="Configuraciones">
              <Route
                path=""
                element={
                  <PrivateRoute allowedRoles={RolesRuta.IPERC_CONFIGURACIONES}>
                    <ConfiguracionMenu />
                  </PrivateRoute>
                }
              >
                <Route
                  path="equiposCheckList"
                  element={<ConfigEquipoCheckList />}
                />
                <Route path="tipoEquipos" element={<ConfigTipoEquipos />} />
                <Route
                  path="modeloEquipos"
                  element={<ConfigModelosEquipos />}
                />
                <Route
                  path="asignacionEquipos"
                  element={<ConfigAsignacionEquipos />}
                />
              </Route>

              <Route path="equipos" element={<ListarEquipoModelo />} />
              <Route path="equipos/:id" element={<DellateEquipoModelo />} />
            </Route>
            <Route path="historial">
              <Route
                path=""
                element={
                  <PrivateRoute
                    allowedRoles={RolesRuta.LISTAVERIFICACION_HISTORIAL}
                  >
                    <ListaVerificacionHistorial />
                  </PrivateRoute>
                }
              />
              <Route
                path="reporteHistoricoC"
                element={<ReporteHistoricoChecklist />}
              />
            </Route>

            <Route path="equipotrabajo" element={<SupervisorHistorial />} />
          </Route>

          <Route path="equiposAuxiliares">
            <Route path="configuraciones">
              <Route path="" element={<ConfiguracionAuxiliarMenu />}>
                <Route path="turnos" element={<Turno />} />
                <Route path="razones" element={<Razon />} />
                <Route path="razonmodelos" element={<RazonModelo />} />
                <Route
                  path="equipomodelooperador"
                  element={<EquipoModeloOperadorTable />}
                />
                <Route path="tajos" element={<Tajo />} />
                <Route path="regiones" element={<Region />} />
                <Route path="ubicaciones" element={<Ubi />} />
                <Route path="equipomodelo" element={<EquipoModeloTable />} />
                <Route path="equipotipo" element={<TipoEquipoTable />} />
              </Route>
            </Route>
            <Route path="operadores" element={<Operador />}></Route>
            <Route path="estados" element={<EstadoEquipo />}></Route>
            <Route path="listado">
              <Route path="" element={<Equipo />} />
              <Route path="detalle" element={<DetalleEquipo />} />
            </Route>
            <Route path="reportes" element={<ReporteHistoricoEstado />} />
          </Route>
          <Route path="hazard">
            <Route path="formulario" element={<FormularioHazard />}></Route>
            <Route path="registros" element={<TablaHazard />}></Route>
            <Route path="configuraciones">
              <Route path="" element={<HazardConfiguracionMenu />}>
                <Route path="grupoincidentes" element={<IncidenteTable />} />
                <Route
                  path="condiciones"
                  element={<CatalogoTable esCondicion={true} />}
                />
                <Route
                  path="actos"
                  element={<CatalogoTable esCondicion={false} />}
                />
                <Route path="elementos" element={<ElementosEstandarTable />} />
                <Route
                  path="ubicaciones"
                  element={
                    <UbicacionHazard
                      nivel={3}
                      nombreNivel={"Ubicación"}
                      descripcion={"Ubicación"}
                    />
                  }
                />
              </Route>
            </Route>
          </Route>

          {/* 1. Gestion IPERC */}
          <Route path="iperc">
            <Route path="" element={<></>} />
            <Route
              path="cuadroMando"
              element={
                <PrivateRoute allowedRoles={RolesRuta.IPERC_CM}>
                  <MandoIPERC />
                </PrivateRoute>
              }
            />
            <Route
              path="base"
              element={
                <PrivateRoute allowedRoles={RolesRuta.IPERC_BASE}>
                  <IpercBaseVista />
                </PrivateRoute>
              }
            />
            <Route path="Configuraciones">
              <Route path="" element={<ConfiguracionMenuIperc />}>
                {/* <Route path="areas" element={<ConfiguracionAreasIperc />} /> */}
                <Route path="areas" element={<IPERCAreas />} />
                <Route path="equipos" element={<ConfiguracionEquiposIperc />} />
                <Route
                  path="actividades"
                  element={<ConfiguracionActividadesIperc />}
                />
                <Route path="ubicaciones" element={<IPERCUbicaciones />} />
                {/* <Route path="ubicaciones" element={<UbicacionTest />} /> */}
              </Route>

              {/* <Route path="equipos" element={<ListarEquipoModelo />} /> */}
              {/* <Route path="equipos/:id" element={<DellateEquipoModelo />} /> */}
            </Route>
            {/* <Route path="historial" element={<IPERCHistorial />} /> */}
            <Route path="historial">
              <Route path="" element={<AdminHistorialIperc />} />
              <Route path="reporteGeneral" element={<ReporteGeneralIperc />} />
            </Route>

            <Route
              path="equipotrabajo"
              element={<SupervisorHistorialIperc />}
            />
            {/* <Route path="Configuraciones">
              <Route path="" element={<ConfiguracionVistaBase />} />
              <Route path="equipos" element={<ListarEquipoModelo />} />
              <Route path="equipos/:id" element={<DellateEquipoModelo />} />
              <Route path="ubicaciones" element={<UbicacionTest />} />
            </Route> */}
            {/* <Route path="equipos" element={<ListarEquipoModelo />} /> */}

            <Route path="MapaProcesos/:id" element={<TablaLineaBase />} />
            {/* <Route path="MapaProcesos" element={<TablaMapaPorceso />} /> */}
            <Route path="MapaProcesos" element={<MapaProcesos />} />
          </Route>

          {/* 1. Gestion Personas */}
          <Route path="personas">
            <Route path="listado" element={<PersonasView />} />
            <Route path="supervisores" element={<ListadoSupervisores />} />
            <Route path="dispositivos" element={<VistaDispositivos />}>
              <Route path="detalle">
                <Route path="historico" element={<DispositivoHistorico />} />
                <Route path="asignados" element={<DispositivosAsignados />} />
                <Route path="devueltos" element={<DispositivosDevueltos />} />
                <Route path="dispositivos" element={<TablaDispositivos />} />
              </Route>
            </Route>
          </Route>

          {/* Gestion Documentos */}
          <Route path="gestionDocumentos">
            <Route path="tipos" element={<VistaTiposDocumentos />} />
            <Route path="grupos" element={<VistaGruposDocumentos />} />
            <Route path="documentos" element={<VistaGestionDocumentos />} />
          </Route>

          <Route path="DetallePersona/:id" element={<DetallePersona />} />
          {/* 4. Configuraciones */}
          <Route path="configuraciones">
            <Route path="usuarios" element={<GestionUsuarios />} />
            <Route path="menuUsuarios">
              <Route path="" element={<CuadroMandoGestionUsuarios />}>
                <Route path="usuarioCuentasRoles" element={<UsuarioCuenta />} />
                {/* <Route path="equipos" element={<ConfiguracionEquiposIperc />} />
                <Route
                  path="actividades"
                  element={<ConfiguracionActividadesIperc />}
                />*/}
              </Route>
            </Route>
          </Route>

          {/* 5. REPORTES */}
          <Route path="Reportes">
            {/* Vista 1 */}
            {/* <Route path="" element={<VistaReportes />} /> */}
            {/* Vista Actuaizada */}
            <Route
              path=""
              element={
                <PrivateRoute allowedRoles={RolesRuta.REPORTES}>
                  <VistaListaReportes />
                </PrivateRoute>
              }
            />
          </Route>

          <Route
            path="*"
            element={<Navigate replace to={`${ConfigHelper.urlLogin()}`} />}
          />
        </Route>
      </Routes>
    </>
  );
};
